// Function to extract URLs from text
export const extractUrls = (text) => {
  // First, extract markdown links to avoid conflicts
  const markdownLinks = [];
  const markdownRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  let match;
  while ((match = markdownRegex.exec(text)) !== null) {
    markdownLinks.push(match[2]); // Store the URL part
  }
  
  // Then extract plain URLs, excluding those already found in markdown
  const urlRegex = /(https?:\/\/[^\s)]+)/g;
  const plainUrls = [];
  while ((match = urlRegex.exec(text)) !== null) {
    const url = match[1];
    // Only add if it's not already in markdown links
    if (!markdownLinks.some(markdownUrl => url.startsWith(markdownUrl))) {
      plainUrls.push(url);
    }
  }
  
  return [...markdownLinks, ...plainUrls];
};

// Function to check if URL is a YouTube video
export const isYouTubeVideo = (url) => {
  return url.includes('youtube.com/watch') || url.includes('youtu.be/');
};

// Function to get YouTube video ID
export const getYouTubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
}; 